import { useEffect, useState } from 'react'
import { Maybe } from 'types/graphqlTypes'
import { getParserVersions } from '../../EdiSelfService/api'
import { Parser, ParserVersion } from '../../EdiSelfService/types'
import { formatParserVersions } from '../../EdiSelfService/utils'

export const useGetCurrentParserVersion = (parser: Maybe<Parser>) => {
  const [parserVersion, setParserVersion] = useState<ParserVersion>()
  const getCurrentParserVersion = async (parser: Parser) => {
    if (parser) {
      const parserVersions = await getParserVersions()
      const currentParserVersions = parserVersions.filter(
        parserVersion => parserVersion.edi_mapper_configurable_parser_id === Number(parser.id)
      )
      const formattedParserVersions = formatParserVersions([parser], currentParserVersions)

      const liveVersion = formattedParserVersions.filter(version => version.is_live === true)[0]

      setParserVersion(liveVersion)
    }
  }

  useEffect(() => {
    if (parser) {
      getCurrentParserVersion(parser)
    }
  }, [parser])

  return parserVersion
}
